import React, {useContext, useEffect} from "../../_snowpack/pkg/react.js";
import {NotificationContext} from "../App.js";
import {Transition} from "../../_snowpack/pkg/@headlessui/react.js";
const Notification = () => {
  const [notification, setNotification] = useContext(NotificationContext);
  useEffect(() => {
    let timer;
    if (notification !== null) {
      timer = setTimeout(() => {
        setNotification(null);
      }, 2e3);
    }
    return () => clearTimeout(timer);
  }, [notification]);
  return /* @__PURE__ */ React.createElement(Transition, {
    show: notification !== null,
    enter: "transition-opacity ease-in duration-100",
    enterFrom: "opacity-0",
    enterTo: "opacity-100",
    leave: "transition-opacity ease-out duration-100",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0"
  }, notification ? /* @__PURE__ */ React.createElement("div", {
    className: `fixed w-screen bottom-0 sm:w-max sm:bottom-5 sm:right-5 p-2 sm:rounded-md ${notification.type === "success" ? "bg-red-200 text-red-600 dark:bg-gray-300 dark:text-gray-800" : "bg-red-700 text-white"} font-semibold text-lg`
  }, notification.message) : /* @__PURE__ */ React.createElement(React.Fragment, null));
};
export default Notification;
